import React, { useState } from 'react';
import { accessControls, dataRoomFiles } from '../mock';

const tagStyles = {
  amber: 'bg-amber-100 text-amber-700',
  green: 'bg-green-100 text-green-700',
  blue: 'bg-blue-100 text-blue-700',
};

const AccessControlList = ({ active, setActive }) => (
  <div className="grid md:grid-cols-3 gap-4 mb-8">
    {accessControls.map((control, index) => (
      <button
        key={control.title}
        onClick={() => setActive(index)}
        className={`rounded-xl border p-5 text-left transition-all ${active === index ? 'border-primary bg-primary/5' : 'border-border bg-card hover:border-primary/30'}`}
      >
        <control.icon className="w-5 h-5 text-primary mb-4" />
        <h3 className="font-display font-semibold text-foreground">{control.title}</h3>
        <p className="mt-1 text-sm text-muted-foreground">{control.desc}</p>
      </button>
    ))}
  </div>
);

const FileBrowser = () => (
  <div className="rounded-2xl border border-border bg-card overflow-hidden shadow-xl shadow-slate-900/5">
    <div className="px-5 py-4 border-b border-border bg-muted/40 font-mono text-xs uppercase tracking-wider text-muted-foreground">
      Issuer Evidence Vault — Example files
    </div>
    <div className="divide-y divide-border">
      {dataRoomFiles.map((file) => (
        <div key={file.name} className="flex items-center justify-between gap-4 px-5 py-4 hover:bg-muted/30 transition-colors">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
              <file.icon className="w-5 h-5 text-primary" />
            </div>
            <div className="min-w-0">
              <div className="font-mono text-sm text-foreground truncate">{file.name}</div>
              <div className="text-xs text-muted-foreground mt-0.5">{file.size}</div>
            </div>
          </div>
          <span className={`rounded-md px-2.5 py-1 font-mono text-[11px] ${tagStyles[file.tagColor] || tagStyles.blue}`}>
            {file.tag}
          </span>
        </div>
      ))}
    </div>
  </div>
);

const DataRoom = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="vault" className="py-24 lg:py-32 bg-muted/20 border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <div className="section-label mb-4">Issuer Evidence Vault</div>
            <h2 className="font-display text-4xl lg:text-5xl font-bold leading-[1.1] tracking-tight text-foreground">
              Keep the legal file beside the digital certificate.
            </h2>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed mb-8">
              The vault stores the issuer profile, legal instrument, asset evidence, transfer rules, wallet attestation, and beneficiary ledger needed to administer a certificate program.
            </p>
            <p className="mt-2 mb-8 text-sm text-muted-foreground leading-relaxed">
              Illustrative example — sample file names and sizes, not real documents. No files are stored or retrieved by this page.
            </p>
            <AccessControlList active={active} setActive={setActive} />
          </div>
          <FileBrowser />
        </div>
      </div>
    </section>
  );
};

export default DataRoom;
